import { render, staticRenderFns } from "./UTableQuestions.vue?vue&type=template&id=3365ca3e&scoped=true&"
import script from "./UTableQuestions.vue?vue&type=script&lang=js&"
export * from "./UTableQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3365ca3e",
  null
  
)

export default component.exports